import {
  AssociatedEntity,
  IValidationResponse,
  ValidationMessage,
} from '@libs/types';

export type AccountTier = 'Enterprise' | 'Standard' | 'LegacyEComm' | null;

export interface IAuthentication {
  init?: boolean;
  exp?: boolean;
  loggedIn: boolean;
  token?: string | null;
  jwt?: Ijwt;
  access?: string[];
  accountId?: string;
  requiredDocuments?: IPactSafeDocument[];
}

export interface Ijwt {
  prn?: string; //memberId
  prt?: string;
  permissionId?: string; //userId
  accountId?: string;
  exp?: number;
  iat?: number;
  iss?: string;
  jti?: string;
}

export interface IAccount {
  id?: string;
  name?: string;
  netSuiteId?: string;
  salesForceId?: string;
  platform?: string;
  accountType?: 'Transactional' | 'Subscription' | null;
  parentAccountId?: string;
  isProgrammatic?: boolean;
  isConnect?: boolean;
  isHubSelfSignup?: boolean; // only exist in employer
  isSinglePostingSponsorship?: boolean; // deprecated, served same purpose as accountTier === 'Standard'
  accountTier?: AccountTier;
  review?: Review;
  createDate?: string;
}

export interface Review {
  id: string;
  reason?: string;
  reviewStatus?: number;
}

export interface IPermissionRequest {
  permissionId: string;
}

export interface IEnterAccountRequest {
  accountId: string;
}

export interface MarketplacePermission {
  id?: string;
  associateEntity?: AssociatedEntity;
  accountId?: string;
  claims?: string[];
  createDate?: string;
  emailAddress?: string;
  firstName?: string;
  lastName?: string;
  memberId?: string;
  hasAllLocations?: boolean;
  roles?: string[];
}

export interface IAuthorization {
  accountId: string;
  id: string;
  permissionId: string;
  roleId: string;
}

export interface IClaim {
  id: string;
  name: string;
}

export interface ISwitchAccount {
  token: string;
  permissionId: string;
  accountId?: string;
}

export interface IUserAccount {
  accountId: string;
  accountName: string;
  permissionId: string;
}

export interface IPactSafeDocument {
  documentName: string;
  documentId: string;
  documentVersionId: string;
  documentKey: string;
}

export interface IPostRequiredDocumentsRequest {
  status: UpdateStatus;
  versionIds: string[];
}

export interface IResponse {
  success: boolean;
  error?: string;
}

export enum UpdateStatus {
  Displayed = 'displayed',
  Updated = 'updated',
  Agreed = 'agreed',
  Visited = 'visited',
  Sent = 'sent',
  Disagreed = 'disagreed',
}

export class PasswordReset implements IValidationResponse {
  userId: string;
  memberId: string;
  newPassword: string;
  oldPassword: string;
  validationMessages: Array<ValidationMessage>;
}
